/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Matrix_LegendInputs */

const cs_portals_matrix_legend = /** @type {(inputs: Portals_Matrix_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portály:`)
};

const en_portals_matrix_legend = /** @type {(inputs: Portals_Matrix_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portals:`)
};

/**
* | output |
* | --- |
* | "Portals:" |
*
* @param {Portals_Matrix_LegendInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_matrix_legend = /** @type {((inputs?: Portals_Matrix_LegendInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Matrix_LegendInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_matrix_legend(inputs)
	return cs_portals_matrix_legend(inputs)
});